/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/molecules/social-links/css/social-links';
import '../../../molecules/footer-image/css/footer-image';
import '../../../molecules/footer-text/css/footer-text';
import '../../footer-navigation/css/footer-navigation';
import './footer.scss';
